@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.harvestdetail.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.harvestdetail.resources/"

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.harvestdetail_back: StringResource by lazy {
      StringResource("string:harvestdetail_back", "harvestdetail_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

@delegate:ResourceContentHash(-1_039_046_639)
internal val Res.string.harvestdetail_complete_chip: StringResource by lazy {
      StringResource("string:harvestdetail_complete_chip", "harvestdetail_complete_chip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 47),
      ))
    }

@delegate:ResourceContentHash(1_976_862_229)
internal val Res.string.harvestdetail_confirm: StringResource by lazy {
      StringResource("string:harvestdetail_confirm", "harvestdetail_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93, 41),
      ))
    }

@delegate:ResourceContentHash(-44_253_536)
internal val Res.string.harvestdetail_dialog_cancel_message: StringResource by lazy {
      StringResource("string:harvestdetail_dialog_cancel_message", "harvestdetail_dialog_cancel_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135, 183),
      ))
    }

@delegate:ResourceContentHash(883_566_273)
internal val Res.string.harvestdetail_dialog_cancel_title: StringResource by lazy {
      StringResource("string:harvestdetail_dialog_cancel_title", "harvestdetail_dialog_cancel_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319, 69),
      ))
    }

@delegate:ResourceContentHash(1_200_103_205)
internal val Res.string.harvestdetail_dialog_complete_message: StringResource by lazy {
      StringResource("string:harvestdetail_dialog_complete_message", "harvestdetail_dialog_complete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 389, 101),
      ))
    }

@delegate:ResourceContentHash(334_712_917)
internal val Res.string.harvestdetail_dialog_complete_title: StringResource by lazy {
      StringResource("string:harvestdetail_dialog_complete_title", "harvestdetail_dialog_complete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 491, 75),
      ))
    }

@delegate:ResourceContentHash(-1_185_133_926)
internal val Res.string.harvestdetail_full_notice: StringResource by lazy {
      StringResource("string:harvestdetail_full_notice", "harvestdetail_full_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 567, 57),
      ))
    }

@delegate:ResourceContentHash(1_283_702_415)
internal val Res.string.harvestdetail_join_cta: StringResource by lazy {
      StringResource("string:harvestdetail_join_cta", "harvestdetail_join_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 625, 58),
      ))
    }

@delegate:ResourceContentHash(1_263_744_000)
internal val Res.string.harvestdetail_leave_cta: StringResource by lazy {
      StringResource("string:harvestdetail_leave_cta", "harvestdetail_leave_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 684, 63),
      ))
    }

@delegate:ResourceContentHash(867_353_065)
internal val Res.string.harvestdetail_login_cta: StringResource by lazy {
      StringResource("string:harvestdetail_login_cta", "harvestdetail_login_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 748, 47),
      ))
    }

@delegate:ResourceContentHash(955_351_198)
internal val Res.string.harvestdetail_login_prompt_join: StringResource by lazy {
      StringResource("string:harvestdetail_login_prompt_join", "harvestdetail_login_prompt_join", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 796, 91),
      ))
    }

@delegate:ResourceContentHash(1_962_776_238)
internal val Res.string.harvestdetail_login_prompt_leave: StringResource by lazy {
      StringResource("string:harvestdetail_login_prompt_leave", "harvestdetail_login_prompt_leave", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 888, 92),
      ))
    }

@delegate:ResourceContentHash(684_488_041)
internal val Res.string.harvestdetail_login_prompt_moderate: StringResource by lazy {
      StringResource("string:harvestdetail_login_prompt_moderate", "harvestdetail_login_prompt_moderate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 981, 107),
      ))
    }

@delegate:ResourceContentHash(-1_523_942_081)
internal val Res.string.harvestdetail_more_actions: StringResource by lazy {
      StringResource("string:harvestdetail_more_actions", "harvestdetail_more_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1089, 54),
      ))
    }

@delegate:ResourceContentHash(1_911_424_970)
internal val Res.string.harvestdetail_not_found_message: StringResource by lazy {
      StringResource("string:harvestdetail_not_found_message", "harvestdetail_not_found_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1144, 107),
      ))
    }

@delegate:ResourceContentHash(1_268_752_270)
internal val Res.string.harvestdetail_not_found_title: StringResource by lazy {
      StringResource("string:harvestdetail_not_found_title", "harvestdetail_not_found_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1252, 77),
      ))
    }

@delegate:ResourceContentHash(223_384_225)
internal val Res.string.harvestdetail_organized_by: StringResource by lazy {
      StringResource("string:harvestdetail_organized_by", "harvestdetail_organized_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1330, 62),
      ))
    }

@delegate:ResourceContentHash(883_564_241)
internal val Res.string.harvestdetail_organizer_cancel: StringResource by lazy {
      StringResource("string:harvestdetail_organizer_cancel", "harvestdetail_organizer_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1393, 66),
      ))
    }

@delegate:ResourceContentHash(-822_377_692)
internal val Res.string.harvestdetail_organizer_complete: StringResource by lazy {
      StringResource("string:harvestdetail_organizer_complete", "harvestdetail_organizer_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1460, 68),
      ))
    }

@delegate:ResourceContentHash(-532_033_532)
internal val Res.string.harvestdetail_organizer_start: StringResource by lazy {
      StringResource("string:harvestdetail_organizer_start", "harvestdetail_organizer_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1529, 65),
      ))
    }

@delegate:ResourceContentHash(174_141_557)
internal val Res.string.harvestdetail_participants_over_capacity: StringResource by lazy {
      StringResource("string:harvestdetail_participants_over_capacity", "harvestdetail_participants_over_capacity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1595, 80),
      ))
    }

@delegate:ResourceContentHash(127_127_642)
internal val Res.string.harvestdetail_participants_overflow: StringResource by lazy {
      StringResource("string:harvestdetail_participants_overflow", "harvestdetail_participants_overflow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1676, 51),
      ))
    }

@delegate:ResourceContentHash(-1_093_466_325)
internal val Res.string.harvestdetail_participants_plural: StringResource by lazy {
      StringResource("string:harvestdetail_participants_plural", "harvestdetail_participants_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1728, 61),
      ))
    }

@delegate:ResourceContentHash(-1_093_466_417)
internal val Res.string.harvestdetail_participants_singular: StringResource by lazy {
      StringResource("string:harvestdetail_participants_singular", "harvestdetail_participants_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1790, 63),
      ))
    }

@delegate:ResourceContentHash(-1_932_350_181)
internal val Res.string.harvestdetail_site_hosted_body: StringResource by lazy {
      StringResource("string:harvestdetail_site_hosted_body", "harvestdetail_site_hosted_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2027, 174),
      ))
    }

@delegate:ResourceContentHash(-1_024_654_862)
internal val Res.string.harvestdetail_site_hosted_body_anonymous: StringResource by lazy {
      StringResource("string:harvestdetail_site_hosted_body_anonymous", "harvestdetail_site_hosted_body_anonymous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1854, 172),
      ))
    }

@delegate:ResourceContentHash(-1_287_910_342)
internal val Res.string.harvestdetail_site_hosted_title: StringResource by lazy {
      StringResource("string:harvestdetail_site_hosted_title", "harvestdetail_site_hosted_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2202, 71),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.harvestdetail_site_rule_ask: StringResource by lazy {
      StringResource("string:harvestdetail_site_rule_ask", "harvestdetail_site_rule_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2274, 55),
      ))
    }

@delegate:ResourceContentHash(1_926_811_893)
internal val Res.string.harvestdetail_site_rule_open: StringResource by lazy {
      StringResource("string:harvestdetail_site_rule_open", "harvestdetail_site_rule_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2330, 52),
      ))
    }

@delegate:ResourceContentHash(-1_238_990_613)
internal val Res.string.harvestdetail_site_rule_private: StringResource by lazy {
      StringResource("string:harvestdetail_site_rule_private", "harvestdetail_site_rule_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2383, 59),
      ))
    }

@delegate:ResourceContentHash(439_552_605)
internal val Res.string.harvestdetail_site_unavailable: StringResource by lazy {
      StringResource("string:harvestdetail_site_unavailable", "harvestdetail_site_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2443, 82),
      ))
    }

@delegate:ResourceContentHash(-1_044_443_951)
internal val Res.string.harvestdetail_status_cancelled: StringResource by lazy {
      StringResource("string:harvestdetail_status_cancelled", "harvestdetail_status_cancelled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2616, 50),
      ))
    }

@delegate:ResourceContentHash(1_053_723_991)
internal val Res.string.harvestdetail_status_cancelled_notice: StringResource by lazy {
      StringResource("string:harvestdetail_status_cancelled_notice", "harvestdetail_status_cancelled_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2526, 89),
      ))
    }

@delegate:ResourceContentHash(-2_088_502_479)
internal val Res.string.harvestdetail_status_completed: StringResource by lazy {
      StringResource("string:harvestdetail_status_completed", "harvestdetail_status_completed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2753, 50),
      ))
    }

@delegate:ResourceContentHash(-1_482_709_889)
internal val Res.string.harvestdetail_status_completed_notice: StringResource by lazy {
      StringResource("string:harvestdetail_status_completed_notice", "harvestdetail_status_completed_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2667, 85),
      ))
    }

@delegate:ResourceContentHash(-1_716_526_061)
internal val Res.string.harvestdetail_status_expired: StringResource by lazy {
      StringResource("string:harvestdetail_status_expired", "harvestdetail_status_expired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2900, 48),
      ))
    }

@delegate:ResourceContentHash(-64_054_087)
internal val Res.string.harvestdetail_status_expired_notice: StringResource by lazy {
      StringResource("string:harvestdetail_status_expired_notice", "harvestdetail_status_expired_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2804, 95),
      ))
    }

@delegate:ResourceContentHash(762_899_012)
internal val Res.string.harvestdetail_status_ongoing: StringResource by lazy {
      StringResource("string:harvestdetail_status_ongoing", "harvestdetail_status_ongoing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2949, 48),
      ))
    }

@delegate:ResourceContentHash(2_088_296_008)
internal val Res.string.harvestdetail_status_planned: StringResource by lazy {
      StringResource("string:harvestdetail_status_planned", "harvestdetail_status_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2998, 52),
      ))
    }

@delegate:ResourceContentHash(-1_957_024_003)
internal val Res.string.harvestdetail_title: StringResource by lazy {
      StringResource("string:harvestdetail_title", "harvestdetail_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3112, 39),
      ))
    }

@delegate:ResourceContentHash(-274_287_189)
internal val Res.string.harvestdetail_title_fallback: StringResource by lazy {
      StringResource("string:harvestdetail_title_fallback", "harvestdetail_title_fallback", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3051, 60),
      ))
    }

@delegate:ResourceContentHash(-1_301_858_267)
internal val Res.string.harvestdetail_tree_unavailable: StringResource by lazy {
      StringResource("string:harvestdetail_tree_unavailable", "harvestdetail_tree_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3152, 82),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("harvestdetail_back", Res.string.harvestdetail_back)
  map.put("harvestdetail_complete_chip", Res.string.harvestdetail_complete_chip)
  map.put("harvestdetail_confirm", Res.string.harvestdetail_confirm)
  map.put("harvestdetail_dialog_cancel_message", Res.string.harvestdetail_dialog_cancel_message)
  map.put("harvestdetail_dialog_cancel_title", Res.string.harvestdetail_dialog_cancel_title)
  map.put("harvestdetail_dialog_complete_message", Res.string.harvestdetail_dialog_complete_message)
  map.put("harvestdetail_dialog_complete_title", Res.string.harvestdetail_dialog_complete_title)
  map.put("harvestdetail_full_notice", Res.string.harvestdetail_full_notice)
  map.put("harvestdetail_join_cta", Res.string.harvestdetail_join_cta)
  map.put("harvestdetail_leave_cta", Res.string.harvestdetail_leave_cta)
  map.put("harvestdetail_login_cta", Res.string.harvestdetail_login_cta)
  map.put("harvestdetail_login_prompt_join", Res.string.harvestdetail_login_prompt_join)
  map.put("harvestdetail_login_prompt_leave", Res.string.harvestdetail_login_prompt_leave)
  map.put("harvestdetail_login_prompt_moderate", Res.string.harvestdetail_login_prompt_moderate)
  map.put("harvestdetail_more_actions", Res.string.harvestdetail_more_actions)
  map.put("harvestdetail_not_found_message", Res.string.harvestdetail_not_found_message)
  map.put("harvestdetail_not_found_title", Res.string.harvestdetail_not_found_title)
  map.put("harvestdetail_organized_by", Res.string.harvestdetail_organized_by)
  map.put("harvestdetail_organizer_cancel", Res.string.harvestdetail_organizer_cancel)
  map.put("harvestdetail_organizer_complete", Res.string.harvestdetail_organizer_complete)
  map.put("harvestdetail_organizer_start", Res.string.harvestdetail_organizer_start)
  map.put("harvestdetail_participants_over_capacity", Res.string.harvestdetail_participants_over_capacity)
  map.put("harvestdetail_participants_overflow", Res.string.harvestdetail_participants_overflow)
  map.put("harvestdetail_participants_plural", Res.string.harvestdetail_participants_plural)
  map.put("harvestdetail_participants_singular", Res.string.harvestdetail_participants_singular)
  map.put("harvestdetail_site_hosted_body", Res.string.harvestdetail_site_hosted_body)
  map.put("harvestdetail_site_hosted_body_anonymous", Res.string.harvestdetail_site_hosted_body_anonymous)
  map.put("harvestdetail_site_hosted_title", Res.string.harvestdetail_site_hosted_title)
  map.put("harvestdetail_site_rule_ask", Res.string.harvestdetail_site_rule_ask)
  map.put("harvestdetail_site_rule_open", Res.string.harvestdetail_site_rule_open)
  map.put("harvestdetail_site_rule_private", Res.string.harvestdetail_site_rule_private)
  map.put("harvestdetail_site_unavailable", Res.string.harvestdetail_site_unavailable)
  map.put("harvestdetail_status_cancelled", Res.string.harvestdetail_status_cancelled)
  map.put("harvestdetail_status_cancelled_notice", Res.string.harvestdetail_status_cancelled_notice)
  map.put("harvestdetail_status_completed", Res.string.harvestdetail_status_completed)
  map.put("harvestdetail_status_completed_notice", Res.string.harvestdetail_status_completed_notice)
  map.put("harvestdetail_status_expired", Res.string.harvestdetail_status_expired)
  map.put("harvestdetail_status_expired_notice", Res.string.harvestdetail_status_expired_notice)
  map.put("harvestdetail_status_ongoing", Res.string.harvestdetail_status_ongoing)
  map.put("harvestdetail_status_planned", Res.string.harvestdetail_status_planned)
  map.put("harvestdetail_title", Res.string.harvestdetail_title)
  map.put("harvestdetail_title_fallback", Res.string.harvestdetail_title_fallback)
  map.put("harvestdetail_tree_unavailable", Res.string.harvestdetail_tree_unavailable)
}
